// Window and shutter textures.
import { rnd } from '../lib/random.js';
import { canvasTex } from '../lib/factory.js';

// ---------- textures ----------
const winTex = canvasTex(256, 256, (c) => {
  c.fillStyle = '#fff';
  c.fillRect(0, 0, 256, 256);
  for (let i = 0; i < 4; i++)
    for (let j = 0; j < 4; j++) {
      const x = i * 64,
        y = j * 64;
      if (rnd() < 0.35) {
        c.fillStyle = '#7f9c78';
        c.fillRect(x + 11, y + 10, 9, 38);
        c.fillRect(x + 44, y + 10, 9, 38);
      }
      c.fillStyle = '#5b6676';
      c.fillRect(x + 20, y + 10, 24, 38);
      c.fillStyle = '#fff';
      c.fillRect(x + 31, y + 10, 2, 38);
      c.fillStyle = '#4b4038';
      c.fillRect(x + 14, y + 46, 36, 5);
      c.fillRect(x + 14, y + 38, 2, 9);
      c.fillRect(x + 48, y + 38, 2, 9);
    }
});
const winEm = canvasTex(256, 256, (c) => {
  c.fillStyle = '#000';
  c.fillRect(0, 0, 256, 256);
  for (let i = 0; i < 4; i++)
    for (let j = 0; j < 4; j++)
      if (rnd() < 0.45) {
        c.fillStyle = rnd() < 0.5 ? '#ffd28f' : '#ffe9c2';
        c.fillRect(i * 64 + 20, j * 64 + 10, 24, 38);
      }
});
const BAY = 1.3,
  FLOOR = 0.9;
winTex.repeat.set(1 / (4 * BAY), 1 / (4 * FLOOR));
winEm.repeat.copy(winTex.repeat);

export const slats = canvasTex(32, 64, (c) => {
  c.fillStyle = '#fff';
  c.fillRect(0, 0, 32, 64);
  c.fillStyle = '#7a6650';
  c.fillRect(13, 10, 6, 34);
  c.fillStyle = '#ece3d4';
  c.fillRect(0, 58, 32, 3);
});
slats.repeat.set(10, 16);
